import { type DBSchema, type IDBPDatabase, openDB } from "idb";
import type { VaultRecord } from "./types";

export const UNLOCK_DB_NAME = "crm-pwa-unlock";
const UNLOCK_DB_VERSION = 1;
export const VAULT_ID = "current";
const STORE = "vault";

interface UnlockDbSchema extends DBSchema {
  vault: {
    key: string;
    value: VaultRecord;
  };
}

export type UnlockDatabase = IDBPDatabase<UnlockDbSchema>;

export function openUnlockDb(): Promise<UnlockDatabase> {
  return openDB<UnlockDbSchema>(UNLOCK_DB_NAME, UNLOCK_DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id" });
      }
    },
  });
}

export async function readVaultRecord(db: UnlockDatabase): Promise<VaultRecord | null> {
  const record = await db.get(STORE, VAULT_ID);
  return record ?? null;
}

export async function deleteVaultRecord(db: UnlockDatabase): Promise<void> {
  await db.delete(STORE, VAULT_ID);
}
